import React from "react";

const HamburgerIcon = (props) => (
  <svg
    width="30"
    height="19"
    viewBox="0 0 30 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_416:19198)">
      <path
        opacity="0.5"
        d="M25.6659 13.5546H3.73741C2.75279 13.5546 1.80848 13.1635 1.11225 12.4673C0.416018 11.7711 0.0249023 10.8268 0.0249023 9.84214C0.0249023 8.85752 0.416018 7.91321 1.11225 7.21698C1.80848 6.52075 2.75279 6.12964 3.73741 6.12964H25.6907C26.6753 6.12964 27.6196 6.52075 28.3158 7.21698C29.0121 7.91321 29.4032 8.85752 29.4032 9.84214C29.4032 10.8268 29.0121 11.7711 28.3158 12.4673C27.6196 13.1635 26.6753 13.5546 25.6907 13.5546H25.6659Z"
        fill="#FEB348"
      />
      <path
        d="M5.3623 0.824951H27.3156"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3623 9.05029H27.3156"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3623 17.2756H27.3156"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_416:19198">
        <rect width="29.3783" height="18.1005" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HamburgerIcon;
